import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { getMobileOS } from "../../utils/detect-mobile";
import DateInputCustom from "./components/DateInputCustom";
import DateInputNative from "./components/DateInputNative";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var DateInputWrapper = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DateInputWrapper, _React$PureComponent);
  var _super = _createSuper(DateInputWrapper);
  function DateInputWrapper() {
    var _this;
    _classCallCheck(this, DateInputWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isNative: false
    });
    return _this;
  }
  _createClass(DateInputWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      setTimeout(function () {
        _this2.setState({
          isNative: getMobileOS()
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var Component = this.state.isNative && !this.props.hideNativeView ? DateInputNative : DateInputCustom;
      return /*#__PURE__*/React.createElement("div", {
        className: cx('inputWrapper', this.props.className)
      }, /*#__PURE__*/React.createElement(Component, {
        disabled: this.props.disabled,
        mask: this.props.mask,
        max: this.props.max,
        min: this.props.min,
        name: this.props.name,
        onBlur: this.props.onBlur,
        onChange: this.props.onChange,
        onClick: this.props.onClick,
        onFocus: this.props.onFocus,
        placeholder: this.props.placeholder,
        size: this.props.size,
        status: this.props.status,
        value: this.props.value
      }), this.props.children);
    }
  }]);
  return DateInputWrapper;
}(React.PureComponent);
_defineProperty(DateInputWrapper, "defaultProps", {
  value: null,
  min: null,
  max: null,
  name: null,
  status: null,
  hideNativeView: false
});
export { DateInputWrapper as default };
DateInputWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.any,
  value: PropTypes.instanceOf(Date),
  min: PropTypes.instanceOf(Date),
  max: PropTypes.instanceOf(Date),
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string,
  size: PropTypes.oneOf(['default', 'big']).isRequired,
  status: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  mask: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  hideNativeView: PropTypes.bool
} : {};